/** Роли и права — зеркало apps/api/src/auth/access.ts. */
export type Role = 'superadmin' | 'admin' | 'manager' | 'volunteer';

export const ROLE_LABEL: Record<Role, string> = {
  superadmin: 'суперадмин',
  admin: 'админ',
  manager: 'менеджер',
  volunteer: 'волонтёр',
};

/** Все профили и все пользователи; создаёт, копирует и удаляет профили. */
export function isSuperadmin(role: Role | undefined | null): boolean {
  return role === 'superadmin';
}

/** Настройки профилей и пользователи: суперадмин и админ (админ — в своих профилях). */
export function isAdminLevel(role: Role | undefined | null): boolean {
  return role === 'superadmin' || role === 'admin';
}
